import React from 'react'
import { IncentivosCards } from './IncentivosCards'

export const Incetivos = () => {
    return (
        <div className=''>
            <IncentivosCards />
        </div>
    )
}